import React from 'react';
import { useBlockingRouter } from '../../hooks/useBlockingRouter';
import { Button, Stack } from '@mui/material';
import { useSelector } from 'react-redux';
import { FlattenedUser } from '../../types/user';

// Markup
import MuiModal from '../../mui/MuiModal/MuiModal';

// Utils
import { isOrgAdmin } from '../../lib/helpers';

type SubscriptionChargeFailedModalProps = {
	closeModal: ( open: boolean ) => void;
};

const SubscriptionChargeFailedModal: React.FC<
	SubscriptionChargeFailedModalProps
> = ( { closeModal } ) => {
	const user: FlattenedUser = useSelector( ( state: any ) => state.user );
	const router = useBlockingRouter();

	const isAdmin = user ? isOrgAdmin( user ) : false;

	return (
		<MuiModal
			muiModalProps={ {
				open: true,
				onClose: () => closeModal( false ),
				slotProps: { paper: { id: 'subscription-charge-failed-modal' } },
			} }
			title='Subscription payment failure'
			description={
				isAdmin
					? 'There was an issue processing your subscription payment. Please go to the wallet page and update the card on file for the Charge Account.'
					: 'There was an issue processing your subscription payment. Please let your admin know.'
			}
			controls={
				<Stack direction={ { xs: 'column', md: 'row' } } spacing={ 2 }>
					{ isAdmin ? (
						<Button
							variant='outlined'
							id='close-subscription-charge-failed-btn'
							onClick={ () => closeModal( false ) }
						>
							Later
						</Button>
					) : null }
					<Button
						id={
							isAdmin
								? 'continue-subscription-charge-failed-btn'
								: 'close-subscription-charge-failed-btn'
						}
						onClick={
							isAdmin
								? () => router.push( '/wallet?chargeAccount=true' )
								: () => closeModal( false )
						}
					>
						{ isAdmin ? 'Let’s go!' : 'Got it' }
					</Button>
				</Stack>
			}
		/>
	);
};

export default SubscriptionChargeFailedModal;
